package com.vizio.redwolf.auth.model

import kotlinx.serialization.Serializable

@Serializable
data class UpdateUserDetailsClientRequestInfo(
    val firstName: String?,
    val lastName: String?,
    val phoneNumber: String?,
    val postalCode: String?,
    val birthDate: String?,
    val gender: String?
)